module.exports = __webpack_public_path__ + "img/img_32389_0_481.97fa6477.png";